
// ─── Claude (Anthropic) API Service ──────────────────────────────────────────
// Atendente virtual de triagem da GB Agrotech usando Anthropic Claude

const CHAT_LAMBDA_URL = process.env.REACT_APP_CHAT_LAMBDA_URL;

// ─── System Prompt de Triagem ─────────────────────────────────────────────────
// O system prompt da Ágata vive NO SERVIDOR, em
// `infra/lambda/chat-handler/index.js` → constante TRIAGE_SYSTEM_PROMPT.
// O frontend não envia mais `system`: se enviasse, qualquer visitante poderia
// redefinir o comportamento do modelo chamando a Lambda direto (curl).
// Para alterar o comportamento da Ágata, edite a constante na Lambda.

// ─── Estrutura do Lead coletado ───────────────────────────────────────────────
export const extractLeadFromHistory = (history) => {
  const fullText = history.map(m => `${m.role}: ${m.text}`).join('\n');
  return {
    conversationText: fullText,
    timestamp: new Date().toISOString(),
    source: 'Chatbot GB Agrotech',
  };
};

// ─── Chamada à API Claude (via Lambda proxy — chave nunca chega ao browser) ───
export const sendToClaude = async (history) => {
  // Converte histórico para formato Anthropic (role: user/assistant)
  // A API exige que a primeira mensagem seja do usuário — descarta cabeçalho do bot
  let messages = history.map(msg => ({
    role: msg.role === 'bot' ? 'assistant' : 'user',
    content: [{ type: 'text', text: msg.text }],
  }));
  while (messages.length > 0 && messages[0].role === 'assistant') {
    messages = messages.slice(1);
  }

  const res = await fetch(CHAT_LAMBDA_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ messages }),
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Anthropic API error ${res.status}: ${err}`);
  }

  const data = await res.json();
  const text = data?.content?.[0]?.text ?? '';
  const isComplete = text.includes('[TRIAGEM_COMPLETA]');
  const cleanText = text.replace('[TRIAGEM_COMPLETA]', '').trim();

  return { text: cleanText, isComplete };
};

// ─── Envio do Formulário de Contato via Lambda/SES ───────────────────────────
export const sendContactEmail = async ({ nome, tel, email, msg, captchaToken }) => {
  const LAMBDA_URL = process.env.REACT_APP_LAMBDA_URL;

  const conversation = [
    `Nome: ${nome}`,
    `WhatsApp/Telefone: ${tel}`,
    `E-mail: ${email}`,
    msg ? `Mensagem: ${msg}` : null,
  ].filter(Boolean).join('\n');

  if (!LAMBDA_URL) {
    console.log('📧 CONTATO (Lambda não configurada):', { nome, tel, email, msg });
    return;
  }

  const res = await fetch(LAMBDA_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      conversation,
      timestamp: new Date().toISOString(),
      source: 'Formulário de Contato',
      captchaToken,
    }),
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Lambda error ${res.status}: ${err}`);
  }
};

// ─── Envio do Lead por E-mail via Lambda/SES ─────────────────────────────────
export const sendLeadByEmail = async (history, captchaToken) => {
  const LAMBDA_URL = process.env.REACT_APP_LAMBDA_URL;

  const lead = extractLeadFromHistory(history);
  const conversationFormatted = history
    .map(m => `${m.role === 'bot' ? '🤖 Ágata' : '👤 Produtor'}: ${m.text}`)
    .join('\n\n');

  if (!LAMBDA_URL) {
    console.log('📧 LEAD CAPTURADO (Lambda não configurada):');
    console.log(lead);
    return;
  }

  const res = await fetch(LAMBDA_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      conversation: conversationFormatted,
      timestamp: lead.timestamp,
      source: lead.source,
      captchaToken,
    }),
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Lambda error ${res.status}: ${err}`);
  }
};
